import React, { useContext, useState } from "react"
import "twin.macro"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { graphql } from "gatsby"
import WaterfallMediaWrapper from "./waterfall-media-wrapper"
import WaterfallMediaSizer from "./waterfall-media-sizer"
import AppIcon from "@atoms/icon"
import RippleButton from "../../atoms/ripple-button"
import {
  ACTIONS,
  createAction,
  GlobalDispatchContext,
} from "../../../utils/global-context"
import ZoomImage from "../../molecules/zoom-image"

const WaterfallMedia = ({ item, index }) => {
  const poster = getImage(item.poster.localFile)
  const dispatch = useContext(GlobalDispatchContext)
  const [expanded, setExpanded] = useState(false)
  const expandedImage = getImage(item.full_image?.localFile)
  const handleClick = item.vimeo_url
    ? () => {
        dispatch(createAction(ACTIONS.setVideo, item.vimeo_data))
      }
    : () => {
        setExpanded(true)
      }
  const ranges = [0.2, 0.4, 0.3, 0.25, 0.5]
  return (
    <WaterfallMediaSizer index={index} range={ranges[index % ranges.length]}>
      <WaterfallMediaWrapper
        index={index}
        isPortrait={poster.height > poster.width}
      >
        <GatsbyImage image={poster} alt={item.poster.alternativeText} />
        {(item.vimeo_url || expandedImage) && (
          <button
            tw="absolute inset-0 flex items-center justify-center w-full h-full focus:(outline-none shadow-xl)"
            onClick={handleClick}
          >
            <RippleButton
              as="span"
              tw="bg-white transition-transform p-4 text-white text-opacity-40"
            >
              <AppIcon
                name={item.vimeo_url ? "play_arrow" : "open_in_full"}
                tw="w-6 h-6 block text-brand-blue"
              />
            </RippleButton>
          </button>
        )}
      </WaterfallMediaWrapper>
      {expandedImage && expanded && (
        <ZoomImage image={expandedImage} onClose={() => setExpanded(false)} />
      )}
    </WaterfallMediaSizer>
  )
}

export const fragment = graphql`
  fragment WaterfallMedia on FT_ComponentAtomsMediaElement {
    id
    vimeo_url
    vimeo_data {
      ...VideoData
    }
    poster {
      url
      alternativeText
      localFile {
        childImageSharp {
          gatsbyImageData(width: 420, formats: [AUTO, WEBP, AVIF])
        }
      }
    }
    full_image {
      url
      alternativeText
      localFile {
        childImageSharp {
          gatsbyImageData(width: 1440, formats: [AUTO, WEBP, AVIF])
        }
      }
    }
  }
`

export default WaterfallMedia
